import { useContext } from 'react';
import { DarkModeContext } from '../contexts/DarkModeContext';

export const useDarkMode = () => {
  const { theme, setTheme } = useContext(DarkModeContext);
  return { theme, setTheme };
};
